export interface IPropertyEnvironmentAddressModel {
    Address?: string;
    HouseNumber?: string;
    CityName?: string;
    CityPostcode?: string;
    CountryName?: string;
    CountryCode?: string;
    CountryId?: number;
    GoogleX?: number;
    GoogleY?: number;
}

export class PropertyEnvironmentAddressModel implements IPropertyEnvironmentAddressModel{
    Address?: string;
    HouseNumber?: string;
    CityName?: string;
    CityPostcode?: string;
    CountryName?: string;
	CountryCode?: string;
    CountryId?: number;
    GoogleX?: number;
    GoogleY?: number;
    constructor(options?: IPropertyEnvironmentAddressModel) {
        this.Address = options.Address;
        this.HouseNumber = options.HouseNumber;
        this.CityName = options.CityName;
        this.CityPostcode = options.CityPostcode;
        this.CountryName = options.CountryName;
        this.CountryCode = options.CountryCode;
        this.CountryId = options.CountryId;
        this.GoogleX = options.GoogleX;
        this.GoogleY = options.GoogleY;
    }
}